import { Box, Button, Flex, Menu, MenuButton, Text } from '@chakra-ui/react';

import { ActionMenuList, type ActionMenuItem } from 'components/ActionMenuList';
import DataImportIcon from 'components/Icons/DataImportIcon';
import FigmaListTreeIcon from 'components/Icons/FigmaListTreeIcon';
import FigmaPlusIcon from 'components/Icons/FigmaPlusIcon';
import FigmaTriangleDown from 'components/Icons/FigmaTriangleDown';
import {
  PLAN_HEADER_HORIZONTAL_PADDING,
  PLAN_REVAMP_RADIUS_SM,
  PLAN_TEXT,
  controlHeight,
} from 'pages/PlanRevamp/PlanPageUIRevamp/planPageRevampUi';

import colors from './dataTheme';

interface HeaderProperties {
  onOpen: () => void;
  showAddAction?: boolean;
  onAddAction?: () => void;
}

const Header = ({ onOpen, showAddAction, onAddAction }: HeaderProperties) => {
  const buttonStyles = {
    h: controlHeight,
    px: 3,
    ...PLAN_TEXT.toolbarTab,
    bg: colors.action,
    color: colors.white,
    borderRadius: PLAN_REVAMP_RADIUS_SM,
    border: 'none',
    boxShadow: 'none',
    flexShrink: 0,
    // The app's Button theme stretches to its container unless told otherwise.
    width: 'fit-content',
    minW: 'unset',
    _hover: { bg: colors.actionHover },
    _active: { bg: colors.actionHover },
  };

  const menuItems: ActionMenuItem[] = [
    {
      key: 'source',
      label: 'Source',
      icon: <DataImportIcon color={colors.textDark} size={14} />,
      onSelect: onOpen,
    },
    ...(showAddAction && onAddAction
      ? [
          {
            key: 'action',
            label: 'Action',
            icon: <FigmaListTreeIcon width={14} height={14} color={colors.textDark} />,
            onSelect: onAddAction,
          },
        ]
      : []),
  ];

  return (
    <Flex
      w='100%'
      px={PLAN_HEADER_HORIZONTAL_PADDING}
      py='12px'
      alignItems='center'
      justifyContent='space-between'
      gap={4}
      flexShrink={0}
    >
      <Box minW={0}>
        <Text {...PLAN_TEXT.pageTitle} color={colors.textDark} noOfLines={1}>
          Data
        </Text>
        <Text {...PLAN_TEXT.labelSm} color={colors.textSecondary} mt={1}>
          Manage and explore your model&apos;s source data.
        </Text>
      </Box>

      {/* Actions only exist inside a source, so the list screen has a single
          "Add source" button and the Source/Action menu appears with a source
          open. */}
      {showAddAction ? (
        <Menu closeOnSelect={true} variant='primary'>
          <MenuButton
            as={Button}
            {...buttonStyles}
            leftIcon={<FigmaPlusIcon width={13} height={13} color={colors.white} />}
            rightIcon={<FigmaTriangleDown width={9} height={5} color={colors.white} />}
          >
            Create
          </MenuButton>
          <ActionMenuList minW='170px' items={menuItems} />
        </Menu>
      ) : (
        <Button
          {...buttonStyles}
          leftIcon={<FigmaPlusIcon width={13} height={13} color={colors.white} />}
          onClick={onOpen}
        >
          Add source
        </Button>
      )}
    </Flex>
  );
};

export default Header;
